import { render, staticRenderFns } from "./ResourcesMonitoring.vue?vue&type=template&id=0d9a8bfd&"
import script from "./ResourcesMonitoring.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports